import React, { useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { api } from "../lib/api";
import { staffLabelText } from "./StaffAvatar";

const ANY = "__any_admin__";

// "Send approval to" dropdown — lists only users holding workflow approval rights.
// Empty selection routes the case to the municipal admin queue (default behaviour).
export function ApproverSelect({ code, value, onChange, testId = "approver-select" }) {
  const [approvers, setApprovers] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/t/${code}/users/approvers`)
      .then((r) => { if (alive) setApprovers(r.data || []); })
      .catch(() => { if (alive) setApprovers([]); });
    return () => { alive = false; };
  }, [code]);

  if (approvers === null || approvers.length === 0) return null;

  return (
    <div className="space-y-1" data-testid="approver-select-block">
      <Label className="flex items-center gap-1.5"><UserCheck className="h-4 w-4" /> Send approval to</Label>
      <Select value={value || ANY} onValueChange={(v) => onChange(v === ANY ? "" : v)}>
        <SelectTrigger className="h-11" data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={ANY}>Municipal Admin queue (default)</SelectItem>
          {approvers.map((a) => (
            <SelectItem key={a.id} value={a.id}>
              {staffLabelText(a.name, a.employee_id)} — {(a.role || "").replace(/_/g, " ")}{a.designation ? ` • ${a.designation}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-[11px] text-muted-foreground">Only users with workflow approval rights are listed.</p>
    </div>
  );
}
